import React from 'react';

export function useCalledOnce(callback: React.EffectCallback) {
  const [hasCalled, setHasCalled] = React.useState(false);

  React.useEffect(() => {
    if (!hasCalled) {
      callback();
      setHasCalled(true);
    }
    /**
     * NOTE:
     * The linter wants `callback` to be part of this array. `callback` will have
     * no effect on the outcome of this function so it's safe to include.
     * Let exhaustive-deps do it's job.
     */
    //
  }, [callback, hasCalled]);
}

export function useKeypress(key: string, action: Function, ref?: HTMLElement) {
  React.useEffect(() => {
    function onKeyup(e: KeyboardEvent) {
      if (e.key === key) action();
    }

    const element = ref ?? window;

    element.addEventListener('keyup', onKeyup);
    return () => element.removeEventListener('keyup', onKeyup);
  }, [action, key, ref]);
}
